import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import PHONE_ICON from 'shared/constants/PHONE_ICON';
import { PhoneUtil, StringUtils } from 'utils';

const Phone = ({ phone, phone_type, isReadOnly, callSuspended }) => {
    return (
    <React.Fragment>
        <Popup
            trigger={<Icon name={PHONE_ICON[StringUtils.capitalize(phone_type)] || 'phone'} />}
            content={phone_type}
            position='top center'
            inverted
        />
            <p
                className={(() => {
                    if (!isReadOnly && !callSuspended) {
                        return "ContactInfo__contact";
                    }
                    return [`${isReadOnly ? "ContactInfo__contact--readOnly" : ""}`, `${callSuspended ? "ContactInfo__suspended" : ""}`].filter(className => className).join(" ")
                })()}
            >
                {PhoneUtil.formatPhoneNumber(phone)}
            </p>
            {callSuspended && (
                <Popup
                    trigger={<Icon name="fas fa-ban" color="red" />}
                    content='Call Suspended'
                    position="top center"
                    inverted
                    size='mini'
                />
            )}
    </React.Fragment>
)
};

export default Phone;
